import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import busImage1 from '../assets/images/buses/bus-1.jpeg';

export default function About() {
  const { t } = useTranslation();
  
  const values = [
    {
      icon: '🛡️', 
      title: t('about_security'), 
      desc: t('about_security_desc')
    },
    {
      icon: '⏰', 
      title: t('about_punctuality'), 
      desc: t('about_punctuality_desc')
    },
    {
      icon: '💺', 
      title: t('about_comfort'), 
      desc: t('about_comfort_desc')
    },
    {
      icon: '🤝', 
      title: t('about_service'), 
      desc: t('about_service_desc')
    },
  ];

  return (
    <div className="bg-neutral-50">
      {/* HERO SECTION */}
      <section className="relative min-h-[500px] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-900 to-primary-600" />
        <div className="absolute right-0 top-0 w-1/2 h-full opacity-20">
          <img 
            src={busImage1} 
            alt={t('bus_company')} 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            className="max-w-2xl text-white"
          >
            <h1 className="text-6xl font-display font-bold mb-6">
              {t('about_title')}
            </h1>
            <p className="text-xl leading-relaxed">
              {t('about_subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* CONTENU PRINCIPAL */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="bg-white rounded-3xl p-12 shadow-2xl -mt-24 relative z-10"
          >
            <h2 className="text-3xl font-display font-bold text-neutral-900 mb-6">
              {t('about_who_we_are')}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              {t('about_description')}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-12">
              <div>
                <h3 className="text-2xl font-bold text-primary-600 mb-4">
                  {t('about_mission')}
                </h3>
                <p className="text-gray-700">
                  {t('about_mission_text')}
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-primary-600 mb-4">
                  {t('about_vision')}
                </h3>
                <p className="text-gray-700">
                  {t('about_vision_text')}
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary-50 to-blue-50 rounded-2xl p-8 my-8">
              <p className="text-lg font-semibold text-primary-800 mb-2">
                💡 {t('about_fact')}
              </p>
              <p className="text-gray-700">
                {t('about_fact_text')}
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* VALEURS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl font-display font-bold text-neutral-900 mb-4">
              {t('about_values_title')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('about_values_subtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{ y: -10 }}
                transition={{ delay: i * 0.1, type: "spring" }}
                className="text-center p-8 rounded-2xl bg-neutral-50 hover:shadow-2xl transition"
              >
                <motion.div
                  whileHover={{ rotate: 360, scale: 1.2 }}
                  transition={{ duration: 0.5 }}
                  className="text-5xl mb-6 bg-gradient-to-br from-primary-600 to-accent-500 bg-clip-text text-transparent"
                >
                  {value.icon}
                </motion.div>
                <h3 className="font-display font-bold text-xl text-neutral-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}